/* Built In Imports */

/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';
/* Internal Imports */
/* Components */
import SectionTitle from '@components/HNI/Components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

// import CompWithLeastStyle from '@shi/styleData/CompWithLeastStyle';

/* Services */

/**
 * Renders the BenefitsGroup component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} BenefitsGroup component
 */

const Benefits = ({ sectionContent, region, lang }) => {
  const title = sectionContent.find(el => el._modelApiKey === 'section_title');
  const card_group = sectionContent.find(
    el => el._modelApiKey === 'card_custom_card_group'
  );
  return (
    <>
      <Box px="20px" py={{ md: '2rem' }}>
        <SectionTitle
          titleObj={title}
          px={{ base: '1.5rem', md: '3rem' }}
          fontSize={{ base: '26px', md: '30px' }}
          lineHeight={{ base: '34px', md: '39px' }}
        />
        <Box
          // w={{ base: '100%', md: '850px' }}
          w={{ base: '100%' }}
          maxW={1000}
          m={{ base: '0 auto', md: '0 auto' }}
          p={{ base: '55px 0 25px 0' }}
          textAlign={{ base: 'center' }}
          display={{ base: 'flex', md: 'flex' }}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Box
            display={{ base: 'flex' }}
            gap={{ base: '2rem', md: '1.5rem', lg: '1.2rem' }}
            flexDirection={{ base: 'column', sm: 'row' }}
            justifyContent={{ base: 'flex-start', md: 'space-around' }}
            alignItems={{ base: 'center', sm: 'flex-start' }}
            w="100%"
            flexWrap="wrap"
          >
            {card_group?.cards?.map((data, index) => {
              return (
                <Flex
                  alignItems={{ base: 'center', md: 'center' }}
                  justifyContent="center"
                  flexDirection="column"
                  // w={{ base: '100%', sm: '48%', lg: '50%', xl: '25%' }}
                  p="0 10px"
                  key={nanoid()}
                  // width={{ base: '100%', md: '254px' }}
                  flex={1}
                  w={{ base: 280, md: 320 }}
                >
                  <LazyLoadImageComponent
                    width="100%"
                    loading="lazy"
                    alt={data?.thumbnail?.alt || ''}
                    title={data?.thumbnail?.title}
                    maxW="200px"
                    maxH="200px"
                    w="200px"
                    h="200px"
                    src={data?.thumbnail?.url}
                    m={{ base: '0 auto 22px auto' }}
                    borderRadius={
                      sectionContent.style === 'default' ? '50%' : ''
                    }
                  />
                  <Text
                    as="h6"
                    color="#28231E"
                    // px={{ md: '4rem' }}
                    fontFamily="FedraSerifAStdBook"
                    fontSize={{ base: '22px' }}
                    m={{ base: '10px auto 0px auto', lg: '1rem auto 0' }}
                    w={{ base: '100%', md: '234px', lg: '100%' }}
                    // w="100%"
                    lineHeight="30px"
                    textAlign={'center'}
                    maxW={index === 2 ? '190px' : '270px'}
                  >
                    {data?.title}
                  </Text>
                  <Box maxW="290px">
                    <StructuredTextParser
                      fontFamily="FedraSansStd-book"
                      region={region}
                      textAlign="center"
                      paddingX={{ base: '1.3rem', md: '0', lg: '0' }}
                      lang={lang}
                      color="#28231E"
                      lineHeight="24px"
                      str={render(data.description)}
                    />
                  </Box>
                </Flex>
              );
            })}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Benefits;
